import styled from "styled-components";

export const ModalContent = styled.div`
  color: var(--Text-T01, #333);
  font-family: var(--font-family-body, Inter);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`;
